
import Container from '@/components/container';
import {
  StyleFontWeightType,
  StyleSizeType,
  StyleColorSchemeType,
  StylePositionType,
} from '@/ui-kit/styles/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import Gutter from '@/ui-kit/components/gutter';

export default {
  /**
   * @component Back button in the header
   *
   * @public
   */

  name: 'HeaderBackComponent',
  components: {
    Container,
    Typography,
    Icon,
    Gutter,
  },
  props: {
    pageTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      StyleFontWeightType,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      TypographyType,
      IconType,
    };
  },
  methods: {
    /**
     * Back to button on click handler.
     *
     * @private
     */

    goBack() {
      this.$router.go(-1);
    },
  },
};
